export default "__VITE_ASSET__BLM3ZJPD__"